import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../app-settings/services/localization-service';
import { ReportDesignerTranslatorService } from '../services/report-designer-translator.service';

/**
 * Translates a translation key ***USING RD LOCALE***
 */
@Pipe({ name: 'rdTranslate' })
export class RdTranslatePipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor(private reportDesignerTranslator: ReportDesignerTranslatorService, private localizationService: LocalizationService) { }

  /**
   * Translates a translation key ***USING RD LOCALE***
   * @param input The translation key
   */
  transform(input: string, replacements: Map<string, string> = null): string {
    const overrides = this.localizationService.getTranslationOverride();

    if (overrides?.labels?.length && input.indexOf('.') >= 0) {
      //Used for live preview of translations
      const labels = overrides.labels;

      const widgetNameTranslationKey = input.substring(0, input.indexOf('.')).toLowerCase();
      const fieldNameTranslationKey = input.substring(input.indexOf('.') + 1).toLowerCase();

      const label = labels.find((label) => {
        return label.dtoName.toLowerCase().indexOf(widgetNameTranslationKey) >= 0
          && label.fieldDtoNameJson.toLowerCase().indexOf(fieldNameTranslationKey) >= 0
      });

      if (label) {
        if (label.editedLanguageValue) {
          return label.editedLanguageValue;
        }
        else if (label.defaultLanguageValue) {
          return label.defaultLanguageValue;
        }
        else {
          return 'Error: No translation defined!';
        }
      }
    }

    //Load from dictionary
    let localized = this.reportDesignerTranslator.getString(input);

    if (replacements !== null) {
      for (const [replaceWhat, replaceWith] of replacements) {
        localized = localized.split(replaceWhat).join(replaceWith);
      }
    }
    return localized;
  }
}
